import { useFormik } from 'formik';
import {
  ConfirmationModal,
  ErrorMessage,
  TextInput,
  useAlert,
} from '@employ-engage/common-components';
import { useState } from 'react';
import classNames from 'classnames';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteCompanyFormProps {}

export function DeleteCompanyForm(props: DeleteCompanyFormProps) {
  const { t } = useTranslation(['common']);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [numAssociatedUsers] = useState(0);
  const [numAssociatedEmployees] = useState(0);
  const [numAssociatedForms] = useState(0);
  const [numAssociatedTemplates] = useState(0);

  const { Alert: CompanyDeletedAlert } = useAlert({
    type: 'success',
    title: t('Saved'),
    message: t('Your company has been deleted.'),
  });

  const { Alert: UnableToDeleteCompanyAlert } = useAlert({
    type: 'error',
    title: t('Saved'),
    message: t(
      'Your company could not be deleted...you need to be the owner to delete a company.'
    ),
  });

  const {
    handleSubmit,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    dirty,
  } = useFormik({
    initialValues: {
      confirm: '',
    },
    onSubmit: async (values) => {
      // get number of associated users, forms, and templates
      // const usersQuery = query(
      //   getUserCollectionRef(),
      //   where('claims.companyIds', 'array-contains', company.id)
      // );
      // const usersSnapshot = await getDocs(usersQuery);
      // setNumAssociatedUsers(usersSnapshot.size + 1); // Add 1 for the owner
      // const employeesSnapshot = await getDocs(
      //   getEmployeesCollectionRef(company.id)
      // );
      // setNumAssociatedEmployees(employeesSnapshot.size - 1); // Subtract 1 for the anonymous employee
      // const templatesSnapshot = await getDocs(
      //   getSurveyTemplatesCollectionRef(company.id)
      // );
      // setNumAssociatedTemplates(templatesSnapshot.size);
      // const formsSnapshot = await getDocs(getSurveysCollectionRef(company.id));
      // setNumAssociatedForms(formsSnapshot.size);
      // setOpenConfirmationModal(true);
    },
    validationSchema: Yup.object().shape({
      confirm: Yup.string()
        .required(t('Required'))
        .equals(['CONFIRM'], t("Must type 'CONFIRM'")),
    }),
  });

  const confirmDeleteCompany = async () => {
    // if ((company as Company).ownerId === user?.id) {
    //   const companyId = company?.id;
    //   const deleteCompany = httpsCallable(
    //     functions,
    //     'deleteFirestoreDocuments-recursiveDelete'
    //   );
    //   const removeCompanyIdFromUsers = httpsCallable(
    //     functions,
    //     'deleteFirestoreDocuments-removeCompanyIdFromAllUsers'
    //   );
    //   try {
    //     await removeCompanyIdFromUsers({
    //       companyId,
    //     });
    //     const result = await deleteCompany({
    //       path: getCompanyDocRef(companyId).path,
    //     });
    //     setCompanyDeletedMessage(
    //       `Your company has been deleted. ${JSON.stringify(result)}`
    //     );
    //     fireCompanyDeletedAlert(3000);
    //     setTimeout(() => {
    //       navigate('/');
    //     }, 3000);
    //   } catch (error) {
    //     console.error(error);
    //     setUnableToDeleteCompanyMessage(`Unable to delete company: ${error}`);
    //     fireUnableToDeleteCompanyAlert(10000);
    //   }
    // } else {
    //   fireUnableToDeleteCompanyAlert(3000);
    // }
  };

  const isSubmitDisabled = Object.keys(errors).length > 0 || !dirty;

  return (
    <form className="md:col-span-2" onSubmit={handleSubmit}>
      <div className="col-span-full">
        <label
          htmlFor="confirm"
          className="block text-sm font-medium leading-6 text-light-primaryText"
        >
          {t('Type "CONFIRM" to delete your company')}
        </label>
        <div className="mt-2">
          <TextInput
            id="confirm"
            type="text"
            value={values.confirm}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </div>
        <ErrorMessage errors={errors.confirm} touched={touched.confirm} />
      </div>
      <div className="mt-8 flex">
        <button
          type="submit"
          className={classNames(
            'rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400',
            {
              'opacity-50 cursor-not-allowed': isSubmitDisabled,
            }
          )}
          disabled={isSubmitDisabled}
        >
          {t('Yes, delete my company')}
        </button>
      </div>
      <ConfirmationModal
        text={`Are you sure you want to delete your company? There are: ${numAssociatedUsers} users, ${numAssociatedEmployees} employees, ${numAssociatedForms} forms, and ${numAssociatedTemplates} templates associated with this company.`}
        warningText="This action cannot be undone!"
        open={openConfirmationModal}
        setOpen={setOpenConfirmationModal}
        onConfirm={confirmDeleteCompany}
        onCancel={() => setOpenConfirmationModal(false)}
      />
      <CompanyDeletedAlert />
      <UnableToDeleteCompanyAlert />
    </form>
  );
}

export default DeleteCompanyForm;
